import { render, staticRenderFns } from "./SelectExtension.vue?vue&type=template&id=0fa85840&"
import script from "./SelectExtension.vue?vue&type=script&lang=js&"
export * from "./SelectExtension.vue?vue&type=script&lang=js&"
import style0 from "./SelectExtension.vue?vue&type=style&index=0&id=0fa85840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports